import styled from "styled-components";

export const RedText = styled.p`
  color: red;
`;

export const GreenText = styled.p`
  color: green;
`;
